<template>
  <div
    v-if="show"
    class="form_btn_container max-h-[500px]"
    id="form_btn_container"
  >
    <div class="flex justify-between items-center">
      <h3 style="color: var(--titulo)">{{ form_title }}:</h3>
      <div class="flex items-center gap-2">
        <HistoricoObjetoButton
          model-name="Produto"
          :objeto-id="form_data.id"
          modelo-label="Produto"
          variant="bare"
          icon-only
        />
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          style="color: var(--icon)"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="input_container">
          <label for="codigo" class="input_label text-[var(--text)]">Produto:</label>
          <input
            style="color: var(--text)"
            type="text"
            v-model="formData.produto"
            placeholder="Produto"
            class="input_field"
            :class="{ 'input-required': !formData.produto }"
            :disabled="formData.status === 'desativado'"
          />
        </div>

        <div style="display: flex">
          <label style="min-width: 7rem; color: var(--label)">Descriçao:</label>
          <textarea
            v-model="formData.descricao"
            placeholder="Descrição"
            class="input_field textarea"
            :class="{ 'input-required': !formData.descricao }"
            style="resize: none; color: var(--text)"
            :disabled="formData.status === 'desativado'"
          ></textarea>
        </div>
        <div class="data_set_class">
          <div class="flex justify-between">
            <div class="text-[var(--text)]" style="min-width: 142px">Familia:</div>
            <div
              v-bind:style="{
                color:
                  set_data.id === 0 ? 'var(--obrigatorio)' : 'var(--label)',
              }"
              class="text-right w-full flex items-center gap-2"
            >
              {{ set_data.nome || "Atribuir" }}
              <i
                class="fa-solid fa-pen-to-square edit-icon"
                style="cursor: pointer"
                @click="selectTable('familia')"
                :style="{
                  color:
                    set_data.id === 0
                      ? 'var(--obrigatorio)'
                      : form_data.status === 'desativado'
                      ? 'var(--desativado)'
                      : 'var(--icon)',
                  cursor:
                    form_data.status === 'desativado'
                      ? 'not-allowed'
                      : 'pointer',
                }"
                :disabled="formData.status === 'desativado'"
              >
              </i>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showRight" id="right_form" class="right_form">
        <div class="img_container">
          <div class="img_btn_container">
            <div class="img_container">
              <img id="produto_img" :src="formData.foto" alt="produto image" />
            </div>
            <div style="margin-top: 0.5rem">
              <label for="input-file">
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  style="color: var(--icon); cursor: pointer"
                ></i>
              </label>
              <input
                type="file"
                accept="image/*"
                id="input-file"
                @change="upload_img"
                hidden
                :disabled="formData.status === 'desativado'"
              />
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            gap: 0.5rem;
            padding: 0rem;
            align-self: flex-start;
          "
        >
          <!-- <AppButton v-if="create_btn  && this.validPermission('P0029')"  v-bind:visibility="true" :font_size="11" 
                        left_icon="fa-solid fa-pen-to-square" text="Familia" emitType="select" :color="formData.status == 'desativado' ? '#7B7B99'  : '#ff9b05'"
                        @select="selectTable('familia')" :disabled="formData.status == 'desativado'" /> -->
          <AppButton
            v-if="familySelected && this.validPermission('P0023')"
            v-bind:visibility="true"
            :font_size="11"
            :color="formData.status == 'desativado' ? '#7B7B99' : '#ff9b05'"
            left_icon="fa-solid fa-pen-to-square"
            text="Listagem"
            emitType="select"
            @select="selectTable('relatorio')"
            :disabled="formData.status == 'desativado'"
          />
          <AppButton
            v-if="familySelected && this.validPermission('P0024')"
            v-bind:visibility="true"
            :font_size="11"
            left_icon="fa-solid fa-pen-to-square"
            text="Serviços"
            emitType="select"
            @select="selectTable('servicos')"
            :disabled="formData.status == 'desativado'"
            :color="
              formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'
            "
          />
          <AppButton
            v-if="familySelected && this.validPermission('P0026')"
            v-bind:visibility="true"
            :font_size="11"
            left_icon="fa-solid fa-pen-to-square"
            text="Separadores"
            emitType="select"
            @select="selectTable('separadores')"
            :disabled="formData.status == 'desativado'"
            :color="
              formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'
            "
          />
        </div>
        <div
          style="
            display: flex;
            gap: 0.5rem;
            padding: 0rem;
            align-self: flex-start;
          "
        >
          <AppButton
            v-if="familySelected && this.validPermission('P0025')"
            v-bind:visibility="true"
            :font_size="11"
            left_icon="fa-solid fa-pen-to-square"
            text="Propriedades"
            emitType="select"
            @select="selectTable('propriedades')"
            :disabled="formData.status == 'desativado'"
            :color="
              formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'
            "
          />
          <AppButton
            v-if="familySelected && this.validPermission('P0026')"
            v-bind:visibility="true"
            :font_size="11"
            left_icon="fa-solid fa-pen-to-square"
            text="Spares"
            emitType="select"
            @select="selectTable('spares')"
            :disabled="formData.status == 'desativado'"
            :color="
              formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'
            "
          />
          
        </div>
      </div>
    </div>
    <div style="display: flex; gap: 0.5rem; padding: 1rem">
      <button
        v-if="podeGerir && create_btn && validPermission('P0003')"
        class="btn"
        @click="showConfirm($event, 'create')"
      >
        Criar
      </button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('P0027')"
        class="btn"
        @click="showConfirm($event, 'update')"
        :disabled="formData.status == 'desativado'"
      >
        Atualizar
      </button>
      <button
        v-if="podeGerir && !create_btn && this.validPermission('P0028')"
        class="px-2 py-2 rounded-xl bg-[#ff0000] text-white text-sm"
        @click="showConfirm($event, 'delete')"
      >
        {{ formData.status === "ativo" ? "Desativar" : "Ativar" }}
      </button>
      <Button
        @click="openPopup($event)"
        label="Confirm"
        id="confirmButton"
        :aria-expanded="isVisible"
        :aria-controls="isVisible ? 'confirm' : null"
      />
      <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import { reactive } from "vue";
import { ref } from "vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  mixins: [permissionMixin],
  components: {
    AppButton,
    ConfirmPopUp,
    HistoricoObjetoButton,
  },
  props: {
    podeGerir: {
        type: Boolean,
        default: () => true,
    },
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    showRight: {
      type: Boolean,
      default: () => true,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
    update_visibility: {
      type: Boolean,
      default: () => false,
    },
    disable_visibility: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      formData: {},
      emit_type: "",
      showRightForm: true,
      showPropriedadesForm: false,
      showServicosForm: false,
      servicos: [],
      familySelected: false,
    };
  },

  created() {
    // this.getServicos();
  },

  methods: {
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        this.update();
      } else if (this.emit_type == "delete") {
        this.disable();
      } else if (this.emit_type == "propriedades") {
        this.closeSubForm("propriedades");
      } else {
        this.$emit("show_table", this.emit_type);
      }

      console.log("Confirmed!");
    },
    async getServicos() {
      const res = await axios.get(`${this.baseURl}/api/v1/tpservico/`);
      this.servicos = res.data.data.sort((a, b) => a.id - b.id);
      console.log("servicos:", this.servicos);
    },
    showSubForm(name) {
      if (name == "propriedades") {
        this.showRightForm = false;
        this.showPropriedadesForm = true;
      } else if (name == "servicos") {
        this.showRightForm = false;
        this.showServicosForm = true;
      }
    },
    closeSubForm(name) {
      if (name == "propriedades") {
        this.showRightForm = true;
        this.showPropriedadesForm = false;
      }
    },
    selectTable(name) {
      this.$emit("selectTable", name);
    },
    upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("produto_img");
          img.src = e.target.result;
          // this.formData.foto = e.target.result;
        };
        reader.readAsDataURL(file);
        const formData = new FormData();
        formData.append("foto", file);
        this.formData.newFoto = formData;
      }
    },

    create() {
      if (!this.isValidForm()) return;
      // const formData = this.getFormData();
      this.$emit("create", this.formData);
    },
    update() {
      if (!this.isValidForm()) return;
      // const formData = this.getFormData();
      this.$emit("update", this.formData);
    },

    disable() {
      // if (!this.isValidForm()) return
      // const formData = this.getFormData();
      this.formData.object = "produto";
      this.$emit("disable", this.formData);
    },
    isValidForm() {
      if (!this.formData.produto || !this.formData.descricao) {
        return false;
      }
      return true;
    },

    getFormData() {
      const formDataObject = {
        ...this.formData,
        ...this.set_data,
      };

      return formDataObject;
    },
    close() {
      this.$emit("close");
    },
    updateFormData() {
      this.formData = { ...this.form_data };
    },
    isEmptyField(field) {
      if (["produto", "descricao"].includes(field)) {
        return (
          this.formData[field] === "" || Array.isArray(this.formData[field])
        );
      }

      return false;
    },
  },

  watch: {
    form_data: {
      handler() {
        this.updateFormData();
      },
      immediate: true,
      deep: true,
    },
    set_data: {
      handler() {
        this.formData.familia_id = this.set_data.id;
        this.familySelected = !!this.set_data.id; // This will be true if set_data.id is truthy
        // this.updateFormData();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
@import "primevue/resources/themes/aura-light-green/theme.css";
@import "primevue/resources/themes/saga-blue/theme.css";
@import "primevue/resources/primevue.min.css";
@import "primeicons/primeicons.css";

.form_btn_container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--fundoForm);
  padding: 1rem;
}

.form_container {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: white;
}

label {
  display: block;
  color: white;
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
input[type="password"],
select {
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}

.input_field.textarea {
  width: 200px;
  height: 100px;
}

.btn_div {
  color: white;
  display: flex;
  padding-left: 1rem;
  align-items: center;
  gap: 0.6rem;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: rgb(0, 102, 152);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.data_set {
  font-size: 14px;
  color: white;
  display: flex;
  gap: 0.3rem;
}

.right_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem;
  align-items: center;
}

.img_container {
  margin-top: -0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.signature_container {
  display: flex;
  gap: 1rem;
}

.tpa_certificado_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.signature_div {
  display: flex;
  gap: 1rem;
}

.signature_field_container {
  display: flex;
  width: 100px;
  height: auto;
  background-color: #626288;
  border-radius: 0.2rem;
}

.signature_field_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.2rem;
}

.signature_icon_container {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
}

.right_input_container {
  margin-top: 0.5rem;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 0.5rem;
}

.input_container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.input_label {
  width: 100px;
  color: white;
  font-size: 14px;
}

.input_field {
  flex: 1;
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.rae_container {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 10px;
  padding: 1rem;
  background-color: rgba(93, 93, 152, 0.55);
}

.edit-icon {
  font-size: 16px; /* Tamanho do ícone */
  transition: color 0.3s ease; /* Suaviza a mudança de cor */
}

.edit-icon:hover {
  color: #ffcc00; /* Cor ao passar o mouse */
}

.text-white {
  color: var(--label);
}
</style>
